module.exports = __webpack_public_path__ + "img/10_diamond.ab29da78.jpg";